import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { mergeMap, take } from 'rxjs/operators';

import { TokenSyncService, UserTokens } from '@stylehaven/components';

@Injectable({ providedIn: 'root' })
export class TokenInterceptor implements HttpInterceptor {
    private readonly WHITELISTED_URLS: string[] = ['mediahaven-rest-api/v2', 'workflow/api', 'portal-api/v2'];

    private readonly tokenSyncService: TokenSyncService = inject(TokenSyncService);
    private userTokens$: Observable<UserTokens | null>;

    constructor() {
        this.userTokens$ = this.tokenSyncService.tokens$;
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const isWhitelistedUrl: boolean = this.WHITELISTED_URLS.some((url: string) => request.url.includes(url));

        if (isWhitelistedUrl) {
            return this.userTokens$.pipe(
                take(1),
                mergeMap((token: UserTokens | null) => {
                    const authenticatedRequest: HttpRequest<any> = this.appendAuthorizationToken(
                        request,
                        this.tokenSyncService.tokens
                    );
                    return next.handle(authenticatedRequest);
                })
            );
        } else {
            return next.handle(request);
        }
    }

    private appendAuthorizationToken(request: HttpRequest<any>, token: UserTokens | null): HttpRequest<any> {
        let authenticatedRequest: HttpRequest<any>;

        let headers: HttpHeaders = request.headers || new HttpHeaders();

        if (token?.access_token && token.token_type) {
            headers = headers.append('Authorization', `bearer ${token.access_token}`);
            authenticatedRequest = request.clone({ headers });
        } else {
            authenticatedRequest = request;
        }

        return authenticatedRequest;
    }

    public getAuthorizationHeader(): HttpHeaders {
        let headers: HttpHeaders = new HttpHeaders();

        if (this.tokenSyncService.tokens?.access_token && this.tokenSyncService.tokens.token_type) {
            headers = headers.append('Authorization', `bearer ${this.tokenSyncService.tokens.access_token}`);
        }

        return headers;
    }
}
